var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02Wallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C26.2093 8 28 9.79067 28 12V24C28 26.2093 26.2093 28 24 28H8C5.79067 28 4 26.2093 4 24V8H24ZM23.334 16C22.2296 16.0002 21.334 16.8956 21.334 18C21.334 19.1044 22.2296 19.9998 23.334 20C24.4386 20 25.334 19.1046 25.334 18C25.334 16.8954 24.4386 16 23.334 16Z",
    fill: "#1DCB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M4 8C4 5.79067 5.79067 4 8 4H20C22.2093 4 24 5.79067 24 8H4Z",
    fill: "#1DCB4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Wallet);
export default __webpack_public_path__ + "static/media/02_wallet.00097d754d8afa2585d1705c2a0d7107.svg";
export { ForwardRef as ReactComponent };